var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"new-btn btn--sec-pine-white request-visit",attrs:{"id":"request-visit-button","to":{ name: 'request-visit', params: { accommodationId: _vm.accommodation.idalojamiento }}}},[_vm._v("\n        "+_vm._s(_vm.$t("reservation.request-visit"))+"\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }